import { MapFilterModel } from "@mapmycustomers/shared/types/viewModel/internalModel/MapFilterModel";
import { isDefined } from "@mapmycustomers/shared/util/assert";

import { FILTER_ENTITY_TYPES } from "@app/component/filtering/utils/consts";
import { doesFilterModelHaveIncompleteValues } from "@app/component/filtering/utils/index";

// same as standardHasIncompleteValue, but for maps
export const doesMapFilterModelHaveIncompleteValues = (filters: MapFilterModel): boolean =>
  FILTER_ENTITY_TYPES.some(
    (entityType) =>
      isDefined(filters[entityType]) && doesFilterModelHaveIncompleteValues(filters[entityType]!)
  );
